import React, { useEffect, useState } from "react";
import Content from "../../../../../../layout/content/Content";
import Head from "../../../../../../layout/head/Head";
import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Input,
} from "../../../../../../components/Component";
import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { capitalizeFirstLetter } from "../../../../../../utils/Utils";
import { Form, useForm } from "react-hook-form";
import { apiRequest } from "../../../../../../utils/Api";
import { toast } from "react-toastify";

const ClientProfile = (props) => {
  const [openEditModal, setEditModal] = useState()
  const [loading, setLoading] = useState()
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true)

  const toggleEditModal = () => {
    if (!submitButtonDisabled) setData()
    clearErrors()
    setEditModal(!openEditModal)
  }

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    clearErrors,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (props.data)
      setData()
  }, [props.data, setValue]);

  useEffect(() => {
    if (props.data) {
      const data = getValues()
      if (data.name_first === props.data.name_first && data.name_last === props.data.name_last && data.phone === props.data.phone) {
        setSubmitButtonDisabled(true)
      } else {
        setSubmitButtonDisabled(false)
      }
    }

  }, [watch('name_first'), watch('name_last'), watch('phone')])

  const setData = () => {
    Object.keys(props.data).forEach((key) => {
      setValue(key, props.data[key]);
    });
  }

  const onFormSubmit = async () => {

    try {
      setLoading(true)
      await apiRequest(`/customer/a/client/${props.data.uuid}`, "POST", getValues()).then(async (resp) => {
        if (resp) {
          console.log(resp);
          if (resp.code === 200) {
            console.log(resp);
            props.getClientDetail()
            toast.success('Information Saved!', {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          } else if (resp.code === 401) {
            toast.error(resp.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          } else {
            setLoading(false)
            toast.error('Something went wrong', {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
          // setLoading(false);
        }
      });
    } catch (error) {
      setLoading(false)
      console.log(error);
      toast.error(error, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    setLoading(false)
  }

  // console.log(props);
  return (
    <React.Fragment>
      <Content>
        <Head title="Client Details"></Head>
        <BlockHead size="lg" >
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h4">Client information</BlockTitle>
            </BlockHeadContent>
            {props.data && props.data.owner && <BlockHeadContent>
              <BlockDes>
                <Button onClick={toggleEditModal} color="primary">Edit Information</Button>
              </BlockDes>
            </BlockHeadContent>}
          </BlockBetween>
        </BlockHead>
        <div className="card card-bordered card-stretch">
          <div className="card-inner-group">
            <div className="card-inner p-0">
              <div className="nk-tb-list nk-tb-ulist">

                <hr style={{ margin: "0" }} />
                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "10px 0px 10px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"
                  >
                    First Name
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "10px 20px 10px 0px",
                      width: "50%",
                    }}
                    id="name_first"
                    className="profile-ud-value"
                  >
                    {props.data && capitalizeFirstLetter(props.data.name_first)}
                  </span>
                </div>
                <hr style={{ margin: "0" }} />


                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "10px 0px 10px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"
                  >
                    Last Name
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "10px 20px 10px 0px",
                      width: "50%",
                    }}
                    id="name-last"
                    className="profile-ud-value"
                  >
                    {props.data && props.data.name_last && capitalizeFirstLetter(props.data.name_last)}
                  </span>
                </div>
                {/* <hr style={{ margin: "0" }} />
                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "10px 0px 10px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"
                  >
                    Client ID
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "10px 20px 10px 0px",
                      width: "50%",
                    }}
                    id="suffix"
                    className="profile-ud-value"
                  >
                    {props.data && props.data.external_id}
                  </span>
                </div> */}
                <hr style={{ margin: "0" }} />
                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "10px 0px 10px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"

                  >
                    Email
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "10px 20px 10px 0px",
                      width: "50%",
                    }}
                    id="aka"
                    className="profile-ud-value"
                  >
                    {props.data && props.data.email}
                  </span>
                </div>
                <hr style={{ margin: "0" }} />
                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "10px 0px 10px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"
                  >
                    Phone
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "10px 20px 10px 0px",
                      width: "50%",
                    }}
                    id="name_changed"
                    className="profile-ud-value"
                  >
                    {props.data && props.data.phone}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {props.data && !props.data.owner &&
          <>
            <BlockHead size="lg" >
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle tag="h4">Agent information (Owner)</BlockTitle>
                </BlockHeadContent>
                {props.data && props.data.owner && <BlockHeadContent>
                  <BlockDes>
                    <Button onClick={toggleEditModal} color="primary">Edit Information</Button>
                  </BlockDes>
                </BlockHeadContent>}
              </BlockBetween>
            </BlockHead>
            <div className="card card-bordered card-stretch">
              <div className="card-inner-group">
                <div className="card-inner p-0">
                  <div className="nk-tb-list nk-tb-ulist">

                    <hr style={{ margin: "0" }} />
                    <div className="profile-ud wider">
                      <span
                        style={{
                          fontSize: "14px",
                          margin: "10px 0px 10px 20px",
                          width: "50%",
                        }}
                        className="profile-ud-label"
                      >
                        Name
                      </span>

                      <span
                        style={{
                          textAlign: "left",
                          fontSize: "14px",
                          margin: "10px 20px 10px 0px",
                          width: "50%",
                        }}
                        id="name_first"
                        className="profile-ud-value"
                      >
                        {props.data && capitalizeFirstLetter(props.data.agent_name)}
                      </span>
                    </div>
                    <hr style={{ margin: "0" }} />


                    <div className="profile-ud wider">
                      <span
                        style={{
                          fontSize: "14px",
                          margin: "10px 0px 10px 20px",
                          width: "50%",
                        }}
                        className="profile-ud-label"
                      >
                        Phone
                      </span>

                      <span
                        style={{
                          textAlign: "left",
                          fontSize: "14px",
                          margin: "10px 20px 10px 0px",
                          width: "50%",
                        }}
                        id="name-last"
                        className="profile-ud-value"
                      >
                        {props.data && props.data.name_last && capitalizeFirstLetter(props.data.agent_phone)}
                      </span>
                    </div>
                    {/* <hr style={{ margin: "0" }} />
                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "10px 0px 10px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"
                  >
                    Client ID
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "10px 20px 10px 0px",
                      width: "50%",
                    }}
                    id="suffix"
                    className="profile-ud-value"
                  >
                    {props.data && props.data.external_id}
                  </span>
                </div> */}
                    <hr style={{ margin: "0" }} />
                    <div className="profile-ud wider">
                      <span
                        style={{
                          fontSize: "14px",
                          margin: "10px 0px 10px 20px",
                          width: "50%",
                        }}
                        className="profile-ud-label"

                      >
                        Email
                      </span>

                      <span
                        style={{
                          textAlign: "left",
                          fontSize: "14px",
                          margin: "10px 20px 10px 0px",
                          width: "50%",
                        }}
                        id="aka"
                        className="profile-ud-value"
                      >
                        {props.data && props.data.agent_email}
                      </span>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </>

        }


        <Modal isOpen={openEditModal} toggle={toggleEditModal}>
          <ModalHeader
            toggle={toggleEditModal}
            close={
              <button className="close" onClick={toggleEditModal}>
                <Icon name="cross" />
              </button>
            }
          >
            Edit Client Information
          </ModalHeader>

          <ModalBody>
            <form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <div className="form-group">
                <Input
                  type="text"
                  label="First Name"
                  id="name_first"
                  className="form-control-lg form-control"
                  name="name_first"
                  requiredMessage={{
                    required: "This field is required",
                    pattern: {
                      value: /^.{1,40}$/,
                      message: "Max 40 characters",
                    },
                  }}
                  errors={errors}
                  register={register}
                />
                <Input
                  type="text"
                  label="Last Name"
                  id="name_last"
                  className="form-control-lg form-control"
                  name="name_last"
                  requiredMessage={{
                    required: "This field is required",
                    pattern: {
                      value: /^.{1,40}$/,
                      message: "Max 40 characters",
                    },
                  }}
                  errors={errors}
                  register={register}
                />
                <Input
                  type="text"
                  label="Phone"
                  id="phone"
                  className="form-control-lg form-control"
                  name="phone"
                  requiredMessage={{
                    required: "This field is required",
                    pattern: {
                      value: /^\+?1?[2-9][0-8][0-9]\d{3}\d{4}$/,
                      message: "Please input valid phone number",
                    },
                  }}
                  errors={errors}
                  register={register}
                />
                <Input
                  type="text"
                  label="Email"
                  id="email"
                  className="form-control-lg form-control"
                  name="email"
                  errors={errors}
                  register={register}
                  disabled
                />
              </div>

              <div className="center mt-2">
                <button
                  type='button'
                  onClick={toggleEditModal}
                  className={`${loading ? "disabled" : ""} center btn border me-2 m-1 closer`}
                  style={{ width: "90px" }}
                >
                  Cancel
                </button>
                <Button color="primary" size="" className={(loading || submitButtonDisabled) && "disabled"} outline="">
                  {!loading ? "Send" : <Spinner />}
                </Button>
              </div>
            </form>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default ClientProfile;
